module.exports = __webpack_public_path__ + "static/media/about-icon.00161274.svg";